import { NextResponse, type NextRequest } from 'next/server'
import type { UpdateOrderPayload, UpdateOrderResponse } from 'ecosystem'
import { type UpdateOrderProviderAdapter } from './types'

/** The update-order flow, shared by every payment provider. */
export const runUpdateOrder = async <TPayload>(
  request: NextRequest,
  adapter: UpdateOrderProviderAdapter<TPayload>
): Promise<NextResponse<UpdateOrderResponse | { error: string }>> => {
  const body = (await request.json()) as UpdateOrderPayload
  const payload = body[adapter.payloadKey] as TPayload | undefined

  if (!payload) {
    return NextResponse.json({ error: 'Wrong payload' }, { status: 400 })
  }

  const { error, response } = await adapter.update(payload)

  if (error || !response) {
    return NextResponse.json({ error: error || 'Unknown error' }, { status: 400 })
  }

  return NextResponse.json(response)
}
